/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * What a vehicle check proves to be valid (FAFD-69). The numeric values are a persistence
contract — never renumber existing members.
 */
export type FacilityFlowCoreModulesFleetEntitiesVehicleCheckKind = typeof FacilityFlowCoreModulesFleetEntitiesVehicleCheckKind[keyof typeof FacilityFlowCoreModulesFleetEntitiesVehicleCheckKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetEntitiesVehicleCheckKind = {
  FirstAidKit: 'FirstAidKit',
  Inspection: 'Inspection',
  Vignette: 'Vignette',
} as const;
